import StaffLoginForm from "@/components/Auth/StaffLoginForm";

export default function AssistantLoginPage() {
    return (
        <StaffLoginForm
            title="Back Office Login"
            subtitle="Sign in to the Back Office / Admin portal"
            backgroundImage="/images/assets/global_cooperation_futuristic_1.png"
        />
    );
}
